import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

import { ScrollArea, ScrollBar } from '@/components/scroll-area'

interface RootProps extends ComponentProps<'div'> {}

function Root({ className, children, ...rest }: RootProps) {
  return (
    <div
      className={twMerge(
        'from-bios-lime-1000 size-52 rounded-3xl bg-linear-to-bl to-bios-primary 2xl:size-64',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

interface ContainerProps extends ComponentProps<'div'> {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

function Container({ icon, className, children, ...rest }: ContainerProps) {
  const Icon = icon

  return (
    <div
      {...rest}
      className={twMerge(
        'flex h-[97%] flex-col items-center justify-center gap-4 rounded-2xl bg-white px-4',
        className,
      )}
    >
      {Icon && (
        <div className="flex size-16 flex-col items-center justify-center rounded-full bg-bios-primary 2xl:size-20">
          <Icon className="size-full text-white" />
        </div>
      )}

      <div>{children}</div>
    </div>
  )
}

interface DescriptionProps extends ComponentProps<'p'> {}

function Description({ className, ...rest }: DescriptionProps) {
  return (
    <p
      className={twMerge(
        'flex-1 text-center text-sm text-monochromatic-500 2xl:text-base',
        className,
      )}
      {...rest}
    />
  )
}

interface DescriptionBoldProps extends ComponentProps<'span'> {}

function DescriptionBold({ className, ...rest }: DescriptionBoldProps) {
  return <span className={twMerge('font-bold', className)} {...rest} />
}

interface ScrollProps {
  children: React.ReactNode
}

function Scroll({ children }: ScrollProps) {
  return (
    <ScrollArea className="-mt-10 pb-2 md:-mt-32 md:overflow-x-hidden md:pb-0">
      <div className="w-max px-1.5 md:w-auto md:px-0">
        <div className="flex items-start justify-start gap-10 md:flex-wrap md:items-center md:justify-center 2xl:gap-20">
          {children}
        </div>
      </div>
      <ScrollBar orientation="horizontal" className="md:hidden" />
    </ScrollArea>
  )
}

export { Root, Container, Description, DescriptionBold, Scroll }
